import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button, Card, CardContent, Container, Grid, MenuItem, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../api/AxiosConfig';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { CKEditorComponent } from '../CKEditor';
import { RHFSelect } from '../../components/hook-form/RHFSelect';
import RHFTextArea from '../../components/hook-form/RHFTextArea';
import { RecruitService } from '../../Services/recruit.service';
import { useLoadingContext } from '../../context/loadingContext';

const EventSchema = Yup.object().shape({
  title: Yup.string().required('Tiêu đề không đươc để trống'),
  recruitLocation: Yup.string().required('Vị trí không được để trống'),
  recruitType: Yup.string().required('Loại việc làm không được để trống'),
});

const RECRUIT_TYPES = ['Toàn thời gian', 'Bán thời gian'];

export const CreateRecruit = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [locations, setLocations] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { handleStartLoading, handleStopLoading } = useLoadingContext()

  useEffect(() => {
    getInitLocation().finally(handleStopLoading);
  }, []);

  const getInitLocation = async () => {
    handleStartLoading()
    const local = await axiosClient.get('/province');
    setLocations(local.data);
  };

  /** React hook form --------------------------------- */
  const defaultValues = {
    title: '',
    price: '',
    recruitLocation: '',
    recruitType: '',
    approveLink: '',
  };

  const methods = useForm({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  /** -------------------------------------------------- */

  const handleOnSubmit = (data) => {
    if (content === '') {
      enqueueSnackbar('Nội dung không được để trống', { variant: 'error' });
      return;
    }
    handleStartLoading()
    RecruitService.CreateRecruit({ ...data, content })
      .then((res) => {
        navigate(`/recruit/view/${res.slug}`, { replace: true, state: '/recruit' });
        enqueueSnackbar('Thêm tuyển dụng mới thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading)
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  return (
    <Page title="Create event">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Thêm bài tuyển dụng mới
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Button
                type="button"
                onClick={handleCancelClick}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="iconoir:cancel" />}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                Save
              </Button>
            </Stack>
          </Stack>
          <Card>
            <CardContent>
              <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                <Grid item xs={12}>
                  <Stack spacing={3}>
                    <RHFTextField name="title" label={'Tiêu đề'} />
                    <RHFTextField name="price" label={'Lương'} />
                    <Typography variant="caption">Lương thỏa thuận nhập giá trị là 0</Typography>
                    <RHFSelect name="recruitLocation" label={'Nơi làm việc'}>
                      {locations.map((location) => (
                        <MenuItem value={location._id} key={location._id}>
                          {location.name}
                        </MenuItem>
                      ))}
                    </RHFSelect>
                    <RHFSelect name="recruitType" label={'Loại việc làm'}>
                      {RECRUIT_TYPES.map((type) => (
                        <MenuItem value={type} key={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </RHFSelect>
                    <RHFTextArea name="approveLink" label={'Link Apply'} />
                  </Stack>
                </Grid>
              </Grid>
              <CKEditorComponent placeholder={'Nội dung bài tuyển dụng'} onValueChange={setContent} value={content} />
            </CardContent>
          </Card>
        </Container>
      </FormProvider>
    </Page>
  );
};
